// A setting's display unit (spec/03 §9): how a settings screen shows and takes a number, never how it
// is stored. Plain values only — no Zod — so `@clavian/contracts/constants` can re-export them to a
// console without pulling `@hono/zod-openapi` into its bundle.
//
// `money`: the value is an integer in the currency's minor unit (paise for INR), as every amount is
// stored and sent (CLAUDE.md, spec/06 §2). The screen shows and accepts it in the major unit — rupees,
// with up to the currency's fraction digits — in the settings view's currency (`scope.currency`), and
// hands the integer minor units back. The value on the wire does not change.
//
// Only `money` exists today. `percent`, `duration` and `count` are the obvious next members; each is a
// new entry here plus its control, never a change to the stored value.
/** The units a setting may declare. A small enum on purpose: add a member, and its control. */
export const SETTING_UNITS = ['money'];
export const isSettingUnit = (value) => typeof value === 'string' && SETTING_UNITS.includes(value);
/**
 * The JSON Schema keyword that carries a unit on a field **inside** a structured setting — the
 * `minTopupAmount` and `bonusAmount` of a top-up offer — where the setting's own `unit` cannot say
 * which field it means. `settingUnit()` puts it there; a screen reads it at any depth.
 */
export const SETTING_UNIT_KEYWORD = 'x-clavian-unit';
//# sourceMappingURL=units.js.map